<div class="jumbotron {{ cssColor }} {{ pageClass }} {{ simulationName }}">
  <div class="container">
    <h1 [attr.aria-label]="getTitle()">{{ pageName }}</h1>
  </div>
</div>
